import { $ } from 'src/shared/js/utils/dom';

const toTopWrapper = $('.back-to-top');

if (toTopWrapper) {
  const header = $('header');
  const footer = $('footer');
  let footerVisible = false;

  function handleScroll() {
    const headerHeight = header.offsetHeight + 200;

    if (footerVisible || window.scrollY < headerHeight) {
      toTopWrapper.classList.remove('is-active');
    } else {
      toTopWrapper.classList.toggle('is-active', true);
    }
  }

  const observer = new IntersectionObserver(
    entries => {
      const entry = entries[0];
      footerVisible = entry.isIntersecting;
      handleScroll();
    },
    { threshold: 0.5 }
  );

  observer.observe(footer);
  document.addEventListener('scroll', handleScroll);
}
